<template>
  <BModal ref="modal" v-model="modalShow" header-class="modal-shared__header" hide-footer v-bind="$attrs" @hide="$emit('hide')">
    <template #modal-header>
      <h5 class="m-0">{{ modalTitle }}</h5>
      <button class="btn btn-clean btn-icon btn-xs" @click="modalShow = false">
        <i class="fa fa-fw fa-times"></i>
      </button>
    </template>
    <slot></slot>
  </BModal>
</template>

<script>
import { BModal } from "bootstrap-vue";

export default {
  components: { BModal },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      modalShow: this.show,
    };
  },
  computed: {
    modalTitle() {
      return this.$attrs?.title || "";
    },
  },
};
</script>

<style></style>
